
<div class="height-100pe" [@routerTransition]>
  <div class="row margin-left-0px">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">

      <div class=" nurse-profile-card-body height-100pe padding-bottom-0px">
        <div class="row height-100pe">
          <div class="col-md-12 padding-left-0px padding-right-0px">
            <div class="card">
              <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px" id="header">
                <div class="row" *ngIf="SelectedPatient">

                  <div class="col-md-1">
                    <img class=" margin-left-6px image-width-scans" [src]="SelectedPatient.PatientImageFile" onError="this.src='dummy.jpg';">
                    
                  </div>
                  <div class="col-md-5 padding-left-23px">
                    <div class="row row-height-17px margin-left-0px">
                      <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                        <label class="margin-bottom-0px font-weight-normal color-secondary" *ngIf="titleapp!=='App'">{{DisplayName}} </label>
                        <label class="margin-bottom-0px font-weight-normal color-secondary" *ngIf="titleapp == 'App' || titleapp == 'cycle' ">{{Displaynameapp}} </label>
                      </div>
                    </div>

                    <div class="row row-height-17px">
                      <div class="col-md-12">
                        <label class="font-size-12px margin-bottom-0px font-weight-normal" *ngIf="titleapp!=='App'">{{FormattedCode}}</label>
                        <label class="font-size-12px margin-bottom-0px font-weight-normal" *ngIf="titleapp == 'App' || titleapp == 'cycle' ">{{FormattedCodeapp}}</label>
                      </div>
                    </div>
                    <div class="row row-height-17px">
                      <div class="col-md-12">
                        <label class="font-size-12px margin-bottom-0px font-weight-normal"><i class="fas fa-phone margin-right-5px"></i>{{SelectedPatient.Telephone1}}</label>
                      </div>
                    </div>
                  </div>
                  
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-12 padding-left-5px padding-right-0px primary-background">
            <div class="margin-top-5px">
              <ul class="nav nav-tabs nav-tab-service2" id="tabContent">
                <li class="active margin-right-5px margin-top-auto margin-bottom-auto font-size-14">
                  <a class="nav-itemerp2 active" href="#ApplicantInfo" data-toggle="tab">Profile</a>
                </li>
                <li class="margin-right-5px margin-top-auto margin-bottom-auto font-size-14">
                  <a class="nav-itemerp2" href="#profileinfo" data-toggle="tab">Message</a>
                </li>
                <li class="margin-right-5px margin-top-auto margin-bottom-auto font-size-14">
                  <a class="nav-itemerp2" href="#documentinfo" data-toggle="tab">Documents</a>
                </li>
                <li class="margin-right-5px margin-top-auto margin-bottom-auto font-size-14">
                  <a class="nav-itemerp2" href="#observationsinfo" data-toggle="tab">Observations</a>
                </li>
                <li class="margin-right-5px margin-top-auto margin-bottom-auto font-size-14">
                  <a class="nav-itemerp2" href="#Orders" data-toggle="tab">Orders</a>
                </li>
                <li class="margin-right-5px margin-top-auto margin-bottom-auto font-size-14">
                  <a class="nav-itemerp2" href="#Prescription" data-toggle="tab">Prescriptions</a>
                </li>
                <li class="margin-right-5px margin-top-auto margin-bottom-auto font-size-14">
                  <a class="nav-itemerp2" href="#healthrecordinfo" data-toggle="tab">Health Records</a>
                </li>
                <li class="margin-right-5px margin-top-auto margin-bottom-auto font-size-14">
                  <a class="nav-itemerp2" href="#visitview" data-toggle="tab">Visits</a>
                </li>
                <li class="margin-right-5px margin-top-auto margin-bottom-auto font-size-14">
                  <a class="nav-itemerp2" href="#billprofile" data-toggle="tab">Bills</a>
                </li>
                <li class="margin-right-5px margin-top-auto margin-bottom-auto font-size-14">
                  <a class="nav-itemerp2" href="#servicelist" data-toggle="tab">Services</a>
                </li>
                <li class="margin-right-5px margin-top-auto margin-bottom-auto font-size-14">
                  <a class="nav-itemerp2" href="#Cycles" data-toggle="tab">Cycles</a>
                </li>

              </ul>
              <div class="tab-content">
                <div class="tab-pane container active margin0px-max-width-100" id="ApplicantInfo" role="tabpanel">

                  <div class="margin-left-0px" id="advanced-form" action="#">
                    <fieldset class="margin-top-10 padding-top-0px margin-left-0px padding-left-0px">
                      <div *ngIf="SelectedPatient" class="margin-left-0px">
                        <personaldetailview [FormattedCode]="SelectedPatient.FormattedCode" [ActorCode]="SelectedPatient.ActorCode"></personaldetailview>

                      </div>
                    </fieldset>
                    
                  </div>
                </div>
                <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px margin-top-10" id="profileinfo" role="tabpanel">
                  <div class="row">
                    <div class="col-md-7">

                      <div class="card">
                        <div class="row">

                          <div class="col-md-12">
                            <div class="card">
                              <div class="card-header wh-header border-bottom1px-solidgray border-left15px-solidgray font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px">
                                <label class="margin-bottom-0px color-backarrow font-size-25px font-weight-bold">Messages</label>

                              </div>
                              <div class="card-body padding-top-0px padding-right-0px">

                                <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps ps2 padding-lrt height-500px" data-ps-id="dfsfsde">
                                  <div *ngFor="let l of CurrentCustomerMessageController">
                                    <div class="row margin-bottom-10px margin-top-10" *ngIf="l.Who2Who=='FromProvider'">
                                      <div class="offset-md-6 col-md-5 text-align-right border-right-sender">


                                        <div class="row">
                                          <div class="col-md-12 padding-left-11px">
                                            <label class="font-size-12px margin-bottom-0px date-color-contracts">{{l.CreatedTimeStamp|date:'dd MMM'}}</label>
                                            <div>
                                              <label class="margin-bottom-0px margin-left-5px font-size-12px color-secondary  padding-left-0px">{{l.Purpose}}</label>
                                            </div>
                                          </div>                                          
                                        </div>
                                        <div class="message-sender">
                                          <div class="row">
                                            <div class="col-md-12 margin-top-4px  font-size-13px text-align-justify">
                                              {{l.MessageText}}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row margin-bottom-10px margin-top-10" *ngIf="l.Who2Who=='FromPatient'">
                                      <div class="offset-md-1 col-md-8 border-left-recevier">
                                        <div class="row">
                                          <div class="col-md-12 padding-left-11px">
                                            <label class="font-size-12px margin-bottom-0px date-color-contracts">{{l.CreatedTimeStamp|date:'dd MMM'}}</label>
                                            <div>
                                              <label class="margin-bottom-0px margin-left-5px font-size-12px color-secondary  padding-left-0px">{{l.Purpose}}</label>
                                            </div>
                                          </div>                                          
                                        </div>
                                        <div class="receiver">
                                          <div class="row">
                                            <div class="col-md-12 margin-top-4px  font-size-13px text-align-justify">
                                              {{l.MessageText}}

                                            </div>
                                          </div>
                                        </div>
                                        di
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>                 
                                           
                    </div>
                    <div class="col-md-5 padding-left-0px">
                      <div class="card affix my-profile-form">
                        <div class="card-header wh-header border-bottom1px-solidgray border-left15px-solidgray font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px">
                          <div class="row">                            
                            <div class="col-md-8">
                              <label class="margin-bottom-0px color-backarrow font-size-25px">Message To Patient</label>

                            </div>
                            <div class="col-md-4">
                              <a class="nav-link-hand education-navlink float-right">
                                <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="card-body margin-left-zero padding-left-0px padding-right-0px">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                            <div class="row margin-bottom-10px margin-left-auto">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"> Purpose</label>
                                  </div>


                                  <div class="col-md-6">
                                    <CodeTypeValue CodeType="PRPS" id="CurrentSaveCustomerMessageRequest.Purpose"
                                                   [(ngModel)]="CurrentSaveCustomerMessageRequest.Purpose" SelectedValue=""
                                                   name="CurrentSaveCustomerMessageRequest.Purpose"></CodeTypeValue>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row margin-left-auto margin-bottom-10px">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Message</label>
                                  </div>
                                  <div class="col-md-6">
                                    <textarea class="form-control3 size-2 width-remarks-206px" rows="2" placeholder="Message" name="CurrentSaveCustomerMessageRequest.MessageText"
                                              [(ngModel)]="CurrentSaveCustomerMessageRequest.MessageText" minlength="1" maxlength="200"
                                              #addconcerns_text="ngModel"></textarea>

                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <button *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand cancel-two margin-left-0px margin-right-5px margin-left-auto">Cancel</button>
                              <button type="submit" class="btn font-size-13px actions-btn-prime  margin-right-auto">Send</button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane container margin-left-0px margin-right-0px" id="documentinfo" role="tabpanel">

                  <div *ngIf="SelectedPatient">
                    <otherdatainfo [ActorCode]="SelectedPatient.ActorCode"></otherdatainfo>

                  </div>
                </div>
                <div class="tab-pane container margin-left-0px margin-right-0px padding-left-0px" id="observationsinfo" role="tabpanel">

                  <div *ngIf="SelectedPatient">
                    <patinettestview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></patinettestview>

                  </div>
                </div>
                <div class="tab-pane container margin-left-0px margin-right-0px padding-right-0px" id="Orders" role="tabpanel">

                  <div *ngIf="SelectedPatient">
                    <ordersprofile [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></ordersprofile>

                  </div>
                </div>
                <div class="tab-pane container margin-left-0px margin-right-0px" id="Prescription" role="tabpanel">

                  <div *ngIf="SelectedPatient">
                    <prescriptionview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></prescriptionview>

                  </div>
                </div>
                <div class="tab-pane container margin-left-0px margin-right-0px" id="healthrecordinfo" role="tabpanel">

                  <div *ngIf="SelectedPatient">
                    <viewedittext [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></viewedittext>

                  </div>
                </div>
                <div class="tab-pane container margin-left-0px margin-right-0px" id="visitview" role="tabpanel">

                  <div *ngIf="SelectedPatient">                    
                    <visitview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></visitview>

                  </div>
                </div>
                <div class="tab-pane container margin-right-0px margin-left-0px" id="billprofile" role="tabpanel">

                  <div *ngIf="SelectedPatient">
                    <billprofile [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode"></billprofile>

                  </div>
                </div>
                <div class="tab-pane container margin-left-0px margin-right-0px padding-right-0px" id="servicelist" role="tabpanel">

                  <div *ngIf="SelectedPatient">
                    <servicesview [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></servicesview>

                  </div>
                </div>
                <div class="tab-pane container margin-left-0px margin-right-0px padding-right-0px" id="Cycles" role="tabpanel">

                  <div *ngIf="SelectedPatient">
                    <cyclesprofile [ActorCode]="SelectedPatient.ActorCode" [FormattedCode]="SelectedPatient.FormattedCode" [PatientCode]="SelectedPatient.PatientRegistrationNumber"></cyclesprofile>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

